<template>
  <div class="menu-main">
    <div>
      <template v-if="menuCategory.length>0">
        <div v-for="category in menuCategory" :key="category" class="category-wrap">
          <!-- category header -->
          <div class="columns is-mobile is-gapless category-header">
            <div class="column is-one-third">
              <span>{{category}}</span>
            </div>
            <div class="column buttons">
              <!-- <span class="max-num" @click="setAllCurrentNum(category)">一括在庫設定</span> -->
              <span class="soldout" @click="setAllSoldout(category)">一括売切</span>
            </div>
          </div>
          <!-- menu -->
          <div
            v-for="(menu, menuIdx) in getMenus(category)"
            :key="menuIdx"
            @click="toMenuDetail(menu.id)"
          >
            <div class="columns is-mobile is-gapless menu">
              <div class="column is-half">{{ menu.name }}</div>
              <div class="column buttons">
                <span class="max-num">
                  <select
                    v-model="menu.maxNum"
                    @change="updateCurrentNum(menu, $event)"
                    @click.stop
                  >
                    <option v-for="num in nums" :value="num.value" :key="num.index">{{ num.value }}</option>
                  </select>
                </span>
                <span
                  class="display"
                  :class="{active: menu.isDisplay}"
                  @click.stop="updateIsDisplay(menu)"
                >{{ getDisplayText(menu.isDisplay) }}</span>
                <span
                  class="soldout"
                  :class="{active: menu.soldout}"
                  @click.stop="updateSoldout(menu)"
                >売切</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>ロード中</template>
    </div>
  </div>
</template>

<script>
import { getFirebase } from "@/firebaseInit";

export default {
  name: "MenuManagement",
  methods: {
    setAllCurrentNum(category) {
      // TODO:
    },
    setAllSoldout(category) {
      for (let idx in this.getMenus(category)) {
        const menu = this.getMenus(category)[idx];
        this.updateSoldout(menu);
      }
    },
    updateCurrentNum(menu, event) {
      let newCurrentNum = null; // defaultはcurrentNumを設定しない
      if (event.target.value != "-") {
        // currentNumを設定する場合上書き
        newCurrentNum = parseInt(event.target.value);
      }
      this.$store
        .dispatch("updateMaxNum", { mid: menu.id, num: newCurrentNum })
        .then(() => {
          this.reloadMenus();
        });
    },
    updateSoldout(menu) {
      let newSoldoutValue = 0;
      if (menu.soldout === 0 || menu.soldout == null) {
        newSoldoutValue = 1;
      } else {
        newSoldoutValue = 0;
      }
      this.$store
        .dispatch("updateSoldout", { mid: menu.id, soldout: newSoldoutValue })
        .then(() => {
          this.reloadMenus();
        });
    },
    updateIsDisplay(menu) {
      let newIsDisplayValue = 0;
      if (menu.isDisplay === 1 || menu.isDisplay == null) {
        newIsDisplayValue = 0;
      } else {
        newIsDisplayValue = 1;
      }
      this.$store
        .dispatch("updateIsDisplay", {
          mid: menu.id,
          isDisplay: newIsDisplayValue
        })
        .then(() => {
          this.reloadMenus();
        })
        .catch(err => console.error(err));
    },
    reloadMenus() {
      // TODO: observer?
      // const menuSnap = await userDB
      //   .ref("menus")
      //   .child(this.$store.state.sid)
      //   .once("value");
      // this.$store.commit("SET_MENUS", { menus: menuSnap.val() });
      this.$store.dispatch("fetchMenus");
    },
    getMenus(category) {
      return Object.values(this.menus).filter(menu => menu.type === category);
    },
    getDisplayText(t) {
      if (t === 0) {
        return "非表示";
      } else {
        return "表示";
      }
    },
    toMenuDetail(mid) {
      this.$router.push("menus/" + mid);
    }
  },
  computed: {
    menus() {
      return this.$store.state.menus;
    },
    menuCategory() {
      let types = [];
      const menus = this.menus;
      for (let mid in menus) {
        const menu = menus[mid];
        const type = menu.type;
        if (type) {
          if (!types.includes(type)) {
            types.push(type);
          }
        }
      }
      return types;
    },
    nums() {
      let current_nums = [{ value: "-", index: 0 }];
      for (let i = 1; i < 100; i++) {
        current_nums.push({ value: `${i}`, index: i });
      }

      return current_nums;
    }
  }
};
</script>

<style scoped>
.menu-main {
  background-color: rgb(241, 241, 241);
}

.category-wrap {
  margin: 20px 0;
  background-color: white;
}

.category-header {
  padding: 10px 0px;
  margin: 10px 20px !important; /* columns のマージンを帳消しする */
  border-bottom: 1px solid #d8d8d8;
}

.category-header div:first-child {
  text-align: left;
  font-weight: bold;
}

.category-header div:last-child {
  text-align: right;
  font-weight: normal;
}

.category-header .buttons .max-num {
  background-color: #d8d8d8;
  border-radius: 3px;
  padding: 3px 7px;
  color: #a0a0a0;
}

.category-header .buttons .soldout {
  background-color: #d8d8d8;
  border-radius: 3px;
  padding: 3px 7px;
  color: #a0a0a0;
}

.menu {
  padding: 10px 0px;
  margin: 10px 20px !important; /* columns のマージンを帳消しする */
  border-bottom: 1px solid #d8d8d8;
}

.menu div:first-child {
  text-align: left;
}

.menu div:last-child {
  text-align: right;
}

.menu .buttons .max-num {
  background-color: #d8d8d8;
  border-radius: 3px;
  padding: 3px 7px;
  color: #a0a0a0;
}

.menu .buttons .max-num select {
}

.menu .buttons .soldout {
  background-color: #d8d8d8;
  border-radius: 3px;
  padding: 3px 7px;
  color: #a0a0a0;
}

.menu .buttons .soldout.active {
  background-color: #ff1654;
  color: white;
}

.menu .buttons .display {
  background-color: #d8d8d8;
  border-radius: 3px;
  padding: 3px 7px;
  color: #a0a0a0;
}

.menu .buttons .display.active {
  background-color: #85ffc7;
  color: black;
}
</style>